import React, { ReactNode } from 'react'

export function StrikableText({ strike, children }: { strike: boolean; children: ReactNode }) {
  return strike ? <s> {children}</s> : <>{children}</>
}
